
import ApiService from './ApiService'

class PasswordService {
    resetPasswordRequest = async (organisationId, email) => {
      var url = '/api/auth/password/request-reset'

      var params = {}

      var options = {
        data: {
          organisationId: organisationId,
          email: email
        }
      }

      var result = await ApiService.postNoToken(url, params, options)
      return result
    }

    resetPassword = async (token, password) => {
      var url = '/api/auth/password/reset'

      var params = {}

      var options = {
        data: {
          token: token,
          password: password
        }
      }

      var result = await ApiService.postNoToken(url, params, options)
      return result
    }
}
export default new PasswordService()
